import { render, staticRenderFns } from "./Redirect.vue?vue&type=template&id=6c4bf78b&scoped=true&"
import script from "./Redirect.vue?vue&type=script&lang=js&"
export * from "./Redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4bf78b",
  null
  
)

export default component.exports